// Author Liang Gang Qiang
// Date 2021-11-04 10:39:39

class MintalMesPrdProductionEquipQuota {
constructor({
        id = null,
        prdResultId = '',
        calendarHour = '',
        workHour = '',
        downtimeHour = '',
        workHour1 = '',
        downtimeHour1 = '',
        workHour2 = '',
        downtimeHour2 = '',
        repairHour = '',
        waitMaterial = '',
        waitElectric = '',
        waitGas = '',
        waitAir = '',
        tinyRepair = '',
        equipment = '',
        electric = '',
        operation = '',
        others = '',
        remark = ''}
= {}) {
    this.id = id;
    this.prdResultId = prdResultId;
    this.calendarHour = calendarHour;
    this.workHour = workHour;
    this.downtimeHour = downtimeHour;
    this.workHour1 = workHour1;
    this.downtimeHour1 = downtimeHour1;
    this.workHour2 = workHour2;
    this.downtimeHour2 = downtimeHour2;
    this.repairHour = repairHour;
    this.waitMaterial = waitMaterial;
    this.waitElectric = waitElectric;
    this.waitGas = waitGas;
    this.waitAir = waitAir;
    this.tinyRepair = tinyRepair;
    this.equipment = equipment;
    this.electric = electric;
    this.operation = operation;
    this.others = others;
    this.remark = remark;
}
}

function newEntity() {
return new MintalMesPrdProductionEquipQuota();
}

const pelletizingVoConfigs = [
        {
        key: 'shiftPlanCode',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.shiftPlanCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'planDay',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.planDay',
        sortable: true,
        form: {
        type: 'datepicker'
        }
        },
        {
        key: 'shiftName',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.shiftName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'calendarHour',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.calendarHour',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'workHour1',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.workHour1',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'downtimeHour1',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.downtimeHour1',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'workHour2',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.workHour2',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'downtimeHour2',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.downtimeHour2',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'repairHour',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.repairHour',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'waitMaterial',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.waitMaterial',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'waitElectric',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.waitElectric',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'waitGas',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.waitGas',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'waitAir',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.waitAir',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'tinyRepair',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.tinyRepair',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'equipment',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.equipment',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'electric',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.electric',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'operation',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.operation',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'others',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.others',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ]
    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'shiftPlanCode',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.shiftPlanCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'planDay',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.planDay',
        sortable: true,
        form: {
        type: 'datepicker'
        }
        },
        {
        key: 'shiftName',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.shiftName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'calendarHour',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.calendarHour',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'workHour',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.workHour',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'downtimeHour',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.downtimeHour',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'workHour1',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.workHour1',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'downtimeHour1',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.downtimeHour1',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'workHour2',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.workHour2',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'downtimeHour2',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.downtimeHour2',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'repairHour',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.repairHour',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'waitMaterial',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.waitMaterial',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'waitElectric',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.waitElectric',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'waitGas',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.waitGas',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'waitAir',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.waitAir',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'tinyRepair',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.tinyRepair',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'equipment',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.equipment',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'electric',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.electric',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'operation',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.operation',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'others',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.others',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}
const smeltingVoConfigs = [
        {
        key: 'shiftPlanCode',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.shiftPlanCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'planDay',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.planDay',
        sortable: true,
        form: {
        type: 'datepicker'
        }
        },
        {
        key: 'shiftName',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.shiftName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'calendarHour',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.calendarHour',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'workHour',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.workHour',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'downtimeHour',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.downtimeHour',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'repairHour',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.repairHour',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'waitMaterial',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.waitMaterial',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'waitElectric',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.waitElectric',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'waitGas',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.waitGas',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'waitAir',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.waitAir',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'tinyRepair',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.tinyRepair',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'equipment',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.equipment',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'electric',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.electric',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'operation',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.operation',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'others',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.others',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ]

const filter = {
    idFilter : '',
    idListFilter : [],
    prdResultIdFilter : '',
    calendarHourFilter : '',
    workHourFilter : '',
    downtimeHourFilter : '',
    workHour1Filter : '',
    downtimeHour1Filter : '',
    workHour2Filter : '',
    downtimeHour2Filter : '',
    repairHourFilter : '',
    waitMaterialFilter : '',
    waitElectricFilter : '',
    waitGasFilter : '',
    waitAirFilter : '',
    tinyRepairFilter : '',
    equipmentFilter : '',
    electricFilter : '',
    operationFilter : '',
    othersFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const pelletizingFilterConfigs = [
        {
        key: 'prdResultIdFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.filter.prdResultId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesPrdProductionResult'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'calendarHourFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.filter.calendarHour',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'workHour1Filter',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.filter.workHour1',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'downtimeHour1Filter',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.filter.downtimeHour1',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'workHour2Filter',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.filter.workHour2',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'downtimeHour2Filter',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.filter.downtimeHour2',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'repairHourFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.filter.repairHour',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'waitMaterialFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.filter.waitMaterial',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'waitElectricFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.filter.waitElectric',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'waitGasFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.filter.waitGas',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'waitAirFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.filter.waitAir',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'tinyRepairFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.filter.tinyRepair',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'equipmentFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.filter.equipment',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'electricFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.filter.electric',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'operationFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.filter.operation',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'othersFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.filter.others',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];
const filterConfigs = [
        {
        key: 'prdResultIdFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.filter.prdResultId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesPrdProductionResult'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'calendarHourFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.filter.calendarHour',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'workHourFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.filter.workHour',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'downtimeHourFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.filter.downtimeHour',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'workHour1Filter',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.filter.workHour1',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'downtimeHour1Filter',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.filter.downtimeHour1',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'workHour2Filter',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.filter.workHour2',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'downtimeHour2Filter',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.filter.downtimeHour2',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'repairHourFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.filter.repairHour',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'waitMaterialFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.filter.waitMaterial',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'waitElectricFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.filter.waitElectric',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'waitGasFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.filter.waitGas',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'waitAirFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.filter.waitAir',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'tinyRepairFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.filter.tinyRepair',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'equipmentFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.filter.equipment',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'electricFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.filter.electric',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'operationFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.filter.operation',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'othersFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.filter.others',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];
const smeltingFilterConfigs = [
        {
        key: 'prdResultIdFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.filter.prdResultId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesPrdProductionResult'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'calendarHourFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.filter.calendarHour',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'workHourFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.filter.workHour',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'downtimeHourFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.filter.downtimeHour',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'repairHourFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.filter.repairHour',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'waitMaterialFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.filter.waitMaterial',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'waitElectricFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.filter.waitElectric',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'waitGasFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.filter.waitGas',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'waitAirFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.filter.waitAir',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'tinyRepairFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.filter.tinyRepair',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'equipmentFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.filter.equipment',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'electricFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.filter.electric',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'operationFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.filter.operation',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'othersFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.filter.others',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const pelletizingEntityConfigs = [
        {
        key: 'prdResultId',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.prdResultId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'mintalMesPrdProductionResult'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'calendarHour',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.calendarHour',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'workHour1',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.workHour1',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'downtimeHour1',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.downtimeHour1',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'workHour2',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.workHour2',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'downtimeHour2',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.downtimeHour2',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'repairHour',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.repairHour',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'waitMaterial',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.waitMaterial',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'waitElectric',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.waitElectric',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'waitGas',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.waitGas',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'waitAir',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.waitAir',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'tinyRepair',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.tinyRepair',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'equipment',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.equipment',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'electric',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.electric',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'operation',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.operation',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'others',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.others',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]
    const entityFormConfigs = [
        {
        key: 'prdResultId',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.prdResultId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'mintalMesPrdProductionResult'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'calendarHour',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.calendarHour',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'workHour',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.workHour',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'downtimeHour',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.downtimeHour',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'workHour1',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.workHour1',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'downtimeHour1',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.downtimeHour1',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'workHour2',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.workHour2',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'downtimeHour2',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.downtimeHour2',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'repairHour',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.repairHour',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'waitMaterial',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.waitMaterial',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'waitElectric',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.waitElectric',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'waitGas',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.waitGas',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'waitAir',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.waitAir',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'tinyRepair',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.tinyRepair',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'equipment',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.equipment',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'electric',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.electric',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'operation',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.operation',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'others',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.others',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]
    const smeltingEntityConfigs = [
        {
        key: 'prdResultId',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.prdResultId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'mintalMesPrdProductionResult'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'calendarHour',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.calendarHour',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'workHour',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.workHour',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'downtimeHour',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.downtimeHour',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'repairHour',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.repairHour',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'waitMaterial',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.waitMaterial',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'waitElectric',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.waitElectric',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'waitGas',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.waitGas',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'waitAir',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.waitAir',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'tinyRepair',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.tinyRepair',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'equipment',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.equipment',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'electric',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.electric',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'operation',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.operation',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'others',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.others',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdProductionEquipQuota.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {MintalMesPrdProductionEquipQuota, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, pelletizingFilterConfigs, filterConfigs, smeltingFilterConfigs
, pelletizingEntityConfigs, smeltingEntityConfigs
, pelletizingVoConfigs, smeltingVoConfigs
}
